var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$store.state.displayType === "textual"
    ? _c("default-textual-section", {
        staticClass: "menu--section-christmas_libations",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": _vm.menuItemComponent,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "beforeTopContentArea",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "menu--section_holiday_divider",
                    attrs: {
                      src: "/library/images/menu/christmas-libations-divider.png",
                      alt: "Holiday Divider",
                      "aria-hidden": "true",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1262773679
        ),
      })
    : _c("default-visual-section", {
        staticClass: "menu--section-christmas_libations",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": _vm.menuItemComponent,
        },
        scopedSlots: _vm._u([
          {
            key: "beforeTopContentArea",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "menu--section_holiday_divider",
                  attrs: {
                    src: "/library/images/menu/christmas-libations-divider.png",
                    alt: "Holiday branch",
                    "aria-hidden": "true",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }